import store from './store';
const hasAccessToken = () => {
    const accessToken = store.get('accessToken', 'session');
    return !!accessToken;
};
export default hasAccessToken;
